

















































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import { Accountext, Package } from 'dapp-client'
import * as helper from '@/assets/_js/helpers'
import ActionButtons from '@/components/common/ActionButtons.vue'
import { currentTime } from '@/assets/_js/helpers'
const numeral = require('numeral')

@Component({
  components: {
    ActionButtons
  }
})
export default class AccountsTableRow extends Vue {
  @Prop() row!: Accountext
  @Prop() count!: number
  @Prop() showAccount!: boolean
  @Prop() showActionBtn!: boolean
  private numeral = numeral
  private pkgJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }
  private dspJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }

  get currentUser() {
    return vxm.transit.currentUser
  }

  get pkg() {
    return vxm.dappservices.packageTable.find(
      (pkg: Package) =>
        pkg.provider === this.row.provider &&
        pkg.package_id === this.row.pending_package &&
        pkg.service === this.row.service
    )
  }

  get progressVariant() {
    if (this.packageEnd.percentage >= 90.0) return 'danger'
    else if (this.packageEnd.percentage >= 75.0) return 'warning'
    else return 'success'
  }

  get packageEnd() {
    const time = helper.currentTime()
    const delta = this.row.package_end - this.row.package_started
    const remaining = this.row.package_end - time
    const percentage = ((remaining / delta) * 100 - 100) * -1
    function msToTime(duration: any) {
      let minutes: any = Math.floor((duration / (1000 * 60)) % 60),
        hours: any = Math.floor((duration / (1000 * 60 * 60)) % 24)

      return hours + 'h ' + minutes + 'min'
    }
    if (time < this.row.package_end) {
      return {
        status: 'active',
        pkgEnd: [this.row.package_end, msToTime(remaining)],
        delta: delta,
        remaining: remaining,
        percentage: percentage
      }
    } else if (
      this.row.status === 'low stake' ||
      this.row.status === 'zero stake'
    ) {
      return {
        status: 'pending',
        pkgEnd: [0, 0],
        delta: delta,
        remaining: remaining,
        percentage: percentage
      }
    } else
      return {
        status: 'expired',
        pkgEnd: [msToTime(this.row.package_end), msToTime(remaining)],
        delta: delta,
        remaining: remaining,
        percentage: percentage
      }
  }

  get getNameLogo() {
    return helper.nameLogo(this.row.provider, this.pkgJson, this.dspJson)
  }

  get prettyServiceString() {
    return helper.prettyServiceString(this.row.service)
  }

  isUser(account: string) {
    if (!this.currentUser) return false
    else if (this.currentUser.accountName === account) return true
  }

  // Lifecycle hooks
  async mounted() {
    if (this.pkg && this.pkg.package_json_uri) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.pkg)
      let dspJson = await vxm.jsondb.getDspJson(this.pkg)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }
  created() {}
  async updated() {
    if (this.pkg && this.pkg.package_json_uri) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.pkg)
      let dspJson = await vxm.jsondb.getDspJson(this.pkg)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }
  destroyed() {}
}
